
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.md?watch=parent';
    export const demoIndex = {
  ids: ["networkgraph-demo-common","networkgraph-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__NetworkGraph" */'/home/runner/work/GPT-Vis/GPT-Vis/src/NetworkGraph/index.md?type=demo')
};